import moment from "moment";

export const delay = ms => new Promise(res => setTimeout(res, ms));
export const today = () => moment.utc().startOf("day");
export const numberWithCommas = number => {
  if (isNaN(number) || number === null) return 0;
  else return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};



// WEBPACK FOOTER //
// ./src/utility/commonHelpers.js